import * as React from 'react';
import {
  addCommas,
  convertDate,
  convertPrice,
  handleBorderColor,
  handleScrollIntoView,
  handleSetQuery,
  HandleValidationMethod,
  removeCommas,
  removeNonNumeric,
  useShowMessageComponent
} from "../../assets/js/main";
import {Backdrop, Box, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import NavBar from "../../components/NavBar";
import {Link, useLocation, useNavigate} from "react-router-dom";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ThemeContext} from "../../App";


export default function Wallet() {
  const {t} = useTranslation()
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const {validationMethod} = HandleValidationMethod()
  const theme = React.useContext(ThemeContext)

  const [tabView, setTabView] = React.useState('0');
  const [selectPrice, setSelectPrice] = React.useState('');
  const [textPrice, setTextPrice] = React.useState('');
  const [totalPrice, setTotalPrice] = React.useState('');
  const [walletBalance, setWalletBalance] = React.useState(0);
  const [walletBalanceList, setWalletBalanceList] = React.useState({});
  const [payMethods, setPayMethods] = React.useState(null);
  const [paymentMethod, setPaymentMethod] = React.useState('');

  const priceList = [
    1000000,
    2000000,
    10000000
  ]

  React.useEffect(() => {
    getWalletBalance()
    walletHistory()
    getPaymentMethods()
  }, [])

  const getWalletBalance = async () => {
    let fetch = await fetchData('', 'GET', '/customer/WalletBalance', '',
       "application/vnd.api+json", '', '',''
    )
    setWalletBalance(fetch?.walletBalance)
  }


  const validationInput = () => {
    (!textPrice) ?
       validationMethod('', 'textPrice_validation', t("error.t29"))
       :
       !paymentMethod ?
          validationMethod('', 'paymentMethod_validation', t("error.t30"))
          : increaseWallet()
  }


  const handleSetPaymentMethodLogo = (e) => {
    switch (e) {
      case "NopFarsi.Payments.SepShaparak":
        return require('./../../assets/img/saman.png')
      case "Payments.Mellat":
        return require('./../../assets/img/mellat.png')
      default:
        return ''
    }
  }

  const increaseWallet = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/increaseWalletBalance', {
         "paymentMethodName": paymentMethod,
         "amountOfIncrease": selectPrice ? Number(selectPrice) : Number(removeCommas(textPrice)),
         "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
       },
       "application/json", '', '',''
    )

    if (fetch?.IsSuccess) {
      // window.open(fetch?.Data)
      window.open(fetch?.Data, '_blank');

      // var popup = window.open(fetch?.Data, 'payment', '_blank' ,true);
      // setTimeout( function() {
      //   if(!popup || popup.outerHeight === 0) {
      //     //First Checking Condition Works For IE & Firefox
      //     //Second Checking Condition Works For Chrome
      //     alert("Popup Blocker is enabled! Please add this site to your exception list.");
      //     window.location.href = 'warning.html';
      //   } else {
      //     //Popup Blocker Is Disabled
      //     window.open(fetch?.Data,'_blank');
      //     window.close();
      //   }
      // }, 25);
    } else if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      enqueueSnackbar(fetch?.Message, {
        variant: 'error',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    }
    dispatch(setLoading(false))
  }

  const walletHistory = async () => {
    let fetch = await fetchData('', 'GET', '/custommerWalletHistory?pageIndex=0&pageSize=10', '',
       "application/json", '', '',''
    )
    setWalletBalanceList(fetch?.Data)
  }

  const getPaymentMethods = async (id) => {
    let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
       "application/json", {
         "orderId": "0",
         "paymentMethodForId": "2"
       }, '',''
    )
    if (fetch?.Data) {
      setPayMethods(fetch?.Data)
    }
  }

  function increaseCreditTemplate() {
    return (
       <>
         <section className="increaseCredit">
           <div className="container">

             <div className="titleSection d-none d-lg-flex">
               <h4>{t("wallet.t1")}</h4>

               <div>
                 <p>
                   {t("wallet.t28")}:
                   <h4>{convertPrice(walletBalance)}</h4>
                   {t("wallet.t12")}
                 </p>

                 <div className="btnGroup_light ml-0 mt-2">
                   <Link to={{pathname: '/wallet/withdrawalRequest', search: location?.search}} className="btnFill" id="textPrice">
                     <span>{t("wallet.t31")}</span>
                   </Link>
                 </div>
               </div>

             </div>
             <div className="s3">
               <div className="row align-items-center">
                 <div className="col-12 col-md-6 mb-5 mb-lg-0">
                   <label>{t("wallet.t2") + ' ' + '(' + t("wallet.t12") + ')'}</label>
                   <input type="text" name="price" className="price" id="price"
                          style={handleBorderColor(selector?.public?.validations?.textPrice_validation)}
                          onChange={(e) => {
                            setTextPrice(addCommas(removeNonNumeric(e.target.value)))
                            setTotalPrice(e.target.value)
                          }} value={textPrice}/>


                   {
                    selector?.public?.validations?.textPrice_validation &&
                     <p className="error">{selector?.public?.validations?.textPrice_validation}</p>
                   }
                   <div className="row">
                     {
                       priceList?.map((item, index) => <div className="col-4" key={index}>
                            <div
                               className={removeCommas(textPrice) == item ? "btnGroup_yellow" : "btnGroup_light"}>
                              <button type="button" className="btnFill" onClick={() => setTextPrice(convertPrice(item))} id="textPrice">
                                <span>{convertPrice(item)}</span>
                              </button>
                            </div>
                          </div>
                       )
                     }
                   </div>
                 </div>

                 <div className="col-12 col-md-6">
                   <FormControl>
                     <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        id="paymentMethod"
                     >
                       {

                         payMethods?.PaymentMethods?.map((item, index) => {
                           return (
                              item?.PaymentMethodSystemName !== "Payments.Wallet" && item?.Name !== "بانک سامان" && <>
                                <FormControlLabel value={item?.PaymentMethodSystemName}
                                                  control={<Radio/>} key={index} label={
                                  <div className="d-flex align-items-center">
                                    <img src={handleSetPaymentMethodLogo(item?.PaymentMethodSystemName)} alt={item?.Name}/>
                                    <span>{item?.Name}</span>
                                  </div>
                                }/>
                              </>
                           )
                         })
                       }
                     </RadioGroup>
                   </FormControl>

                   {
                     selector?.public?.validations?.paymentMethod_validation &&
                     <p className="error">{selector?.public?.validations?.paymentMethod_validation}</p>
                   }
                 </div>
               </div>

               <div className="_btnGroup_yellow">
                 <button className="btnFill" disabled={selector?.loading?.isLoading} onClick={validationInput} id="validationInput">
                   {
                     selector?.loading?.isLoading ?
                        <Box sx={{display: 'flex'}}>
                          <CircularProgress size={20}/>
                        </Box>
                        :
                        <span>{t("wallet.t23")}</span>
                   }
                 </button>
               </div>
             </div>
           </div>
         </section>
       </>
    )
  }

  function listCreditsTemplateMobile() {
    return (
       <>
         <section className="listCreditsMobile">
           <div className="container">
             <div className="s3">
               <div className="filter">
                 <h4 className="titleSection">{t("wallet.t8")}</h4>
                 {/*<div className="filter">*/}
                 {/*  <Select*/}
                 {/*     value={filter}*/}
                 {/*     onChange={(event) => setFilter(event.target.value)}*/}
                 {/*     displayEmpty*/}
                 {/*     inputProps={{'ari a-label': 'Without label'}}*/}
                 {/*  >*/}
                 {/*      <MenuItem value="1">{t("wallet.t9")}</MenuItem>*/}
                 {/*      <MenuItem value="2">{t("wallet.t10")}</MenuItem>*/}
                 {/*      <MenuItem value="3">{t("wallet.t11")}</MenuItem>*/}
                 {/*  </Select>*/}
                 {/*</div>*/}
                 {/*<Select*/}
                 {/*   value={filter}*/}
                 {/*   name="filter"*/}
                 {/*   onChange={(event) => setFilter(event.target.value)}*/}
                 {/*   displayEmpty*/}
                 {/*   inputProps={{'aria-label': 'Without label'}}*/}
                 {/*>*/}
                 {/*  <MenuItem value="1">{t("wallet.t9")}</MenuItem>*/}
                 {/*  <MenuItem value="2">{t("wallet.t10")}</MenuItem>*/}
                 {/*  <MenuItem value="3">{t("wallet.t11")}</MenuItem>*/}
                 {/*</Select>*/}
               </div>
               <div className="infoBody">
                 {
                   walletBalanceList?.walletData?.map((item, index) => {
                     return <div className="items" key={index}>
                       <div className="item">
                         <div className="title">
                           {/*<div className="icon">*/}
                           {/*  <ArrowCircleUp className="success"/>*/}
                           {/*</div>*/}
                           <span> {convertPrice(item?.Points)} {t("wallet.t12")} </span>
                         </div>
                         <div>
                           <p>{convertDate(item?.CreatedOnUtc)}</p>
                           {/*<span className="success">{t("wallet.t13")}</span>*/}
                         </div>
                       </div>
                       <span>{item?.Message}</span>
                     </div>

                     // <tr key={index}>
                     //   <td>{index + 1}</td>
                     //   <td>{item?.Points}</td>
                     //   <td>{convertDate(item?.CreatedOnUtc)}</td>
                     //   <td>{item?.Id}</td>
                     //   <td>{item?.Message}</td>
                     // </tr>
                   })
                 }
               </div>
             </div>
           </div>
         </section>
       </>
    )
  }

  function listCreditsTemplateDesktop() {
    return (
       <>
         <section className="listCreditsDesktop">
           <div className="headerPage titleSection">
             <h4 className="">{t("wallet.t15")}</h4>
             {/*<div className="filter">*/}
             {/*  <Select*/}
             {/*     value={filter}*/}
             {/*     onChange={(event) => setFilter(event.target.value)}*/}
             {/*     displayEmpty*/}
             {/*     inputProps={{'aria-label': 'Without label'}}*/}
             {/*  >*/}
             {/*    <MenuItem value="0">{t("wallet.t9")}</MenuItem>*/}
             {/*    <MenuItem value="1">{t("wallet.t10")}</MenuItem>*/}
             {/*    <MenuItem value="2">{t("wallet.t11")}</MenuItem>*/}
             {/*  </Select>*/}
             {/*</div>*/}
           </div>
           <table>
             <thead>
             <tr>
               <th>{t("wallet.t16")}</th>
               {/*<th>{t("wallet.t17")}</th>*/}
               <th>{t("wallet.t18")}</th>
               <th>{t("wallet.t19")}</th>
               <th>{t("wallet.t20")}</th>
               {/*<th>{t("wallet.t21")}</th>*/}
               <th style={{width: '30%'}}>{t("wallet.t22")}</th>
             </tr>
             </thead>
             <tbody>

             {
               walletBalanceList?.walletData?.map((item, index) => {
                 return <tr key={index}>
                   <td>{index + 1}</td>
                   <td>{convertPrice(item?.Points)}</td>
                   <td>{convertDate(item?.CreatedOnUtc)}</td>
                   <td>{item?.Id}</td>
                   <td>{item?.Message}</td>
                 </tr>
               })
             }

             {/*<tr>*/}
             {/*  <td>1</td>*/}
             {/*  <td>*/}
             {/*    <div className="icon">*/}
             {/*      <ArrowCircleUp className="success"/>*/}
             {/*      {t("wallet.t13")}*/}
             {/*    </div>*/}
             {/*  </td>*/}
             {/*  <td>25،000 {t("wallet.t12")}</td>*/}
             {/*  <td>25 اردیبهشت 1400</td>*/}
             {/*  <td>1547891025</td>*/}
             {/*  <td>58.000.000 {t("wallet.t12")}</td>*/}
             {/*  <td>راساس درخواست مشتری سفارش 897428 کنسل شد .*/}
             {/*    هزینه سفارش کنسل شده به کیف پول ایشان افزوده شد*/}
             {/*  </td>*/}
             {/*</tr>*/}
             {/*<tr>*/}
             {/*  <td>2</td>*/}
             {/*  <td>*/}
             {/*    <div className="icon">*/}
             {/*      <ArrowCircleDown className="failed"/>*/}
             {/*      {t("wallet.t14")}*/}
             {/*    </div>*/}
             {/*  </td>*/}
             {/*  <td>25،000 {t("wallet.t12")}</td>*/}
             {/*  <td>25 اردیبهشت 1400</td>*/}
             {/*  <td>1547891025</td>*/}
             {/*  <td>58.000.000 {t("wallet.t12")}</td>*/}
             {/*  <td>راساس درخواست مشتری سفارش 897428 کنسل شد .*/}
             {/*    هزینه سفارش کنسل شده به کیف پول ایشان افزوده شد*/}
             {/*  </td>*/}
             {/*</tr>*/}
             </tbody>
           </table>


           <div className="paginate">
             {/*<Pagination*/}
             {/*   count={10}*/}
             {/*   renderItem={(item) => (*/}
             {/*      <PaginationItem*/}
             {/*         slots={{previous: ArrowBack, next: ArrowForward}}*/}
             {/*         {...item}*/}
             {/*      />*/}
             {/*   )}*/}
             {/*/>*/}
             {/*<div className="_btnGroup_yellow">*/}
             {/*  <button className="btnFill">*/}
             {/*    <span>{t("wallet.t30")}</span>*/}
             {/*  </button>*/}
             {/*</div>*/}
           </div>
         </section>
       </>
    )
  }

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <NavBar/>

       <div className="walletPage">
         <div className="container-fluid container-lg">
           <div className="row">

             <div className="titleSection d-flex d-lg-none justify-content-center mb-5">
               <div>
                 <p>
                   {t("wallet.t28")}:
                   <h4>{convertPrice(walletBalance)}</h4>
                   {t("wallet.t12")}
                 </p>

                 <div className="btnGroup_light ml-0 mt-2">
                   <a href="https://app.didar.me/customer/form/2735dead-e3f9-4402-aeb0-d58675dbe4e4">
                     <button type="button" className="btnFill" id="textPrice">
                       <span>{t("wallet.t31")}</span>
                     </button>
                   </a>
                 </div>
               </div>
             </div>

             <div className="col-12 d-none d-lg-block">
               <div className="credit">
                 {/*{transferCreditsTemplate()}*/}
                 {increaseCreditTemplate()}

                 {/*<div className="_btnGroup_yellow">*/}
                 {/*  <button className="btnFill" disabled={selector?.loading?.isLoading} onClick={validationInput}>*/}
                 {/*    {*/}
                 {/*      selector?.loading?.isLoading ?*/}
                 {/*         <Box sx={{display: 'flex'}}>*/}
                 {/*           <CircularProgress size={20}/>*/}
                 {/*         </Box>*/}
                 {/*         :*/}
                 {/*         <span>{t("wallet.t23")}</span>*/}
                 {/*    }*/}
                 {/*  </button>*/}
                 {/*</div>*/}

               </div>
             </div>

             <div className="col-12 d-none d-lg-block">
               {listCreditsTemplateDesktop()}
             </div>
           </div>
           <section className="s2 d-flex d-lg-none">
             <div className="tabView">
               <Tabs
                  value={tabView}
                  onChange={(event, newValue) => setTabView(newValue)}
                  aria-label="wrapped label tabs example"
                  id="tabs"
               >
                 <Tab value="0" label={t("wallet.t1")}/>
                 <Tab value="1" label={t("wallet.t29")}/>
                 {/*<Tab value="2" label={t("wallet.t24")}/>*/}
               </Tabs>
             </div>
           </section>
           <div className="d-block d-lg-none">
             {tabView === '0' && increaseCreditTemplate()}
             {tabView === '1' && listCreditsTemplateMobile()}
             {/*{tabView === '2' && transferCreditsTemplate()}*/}
           </div>
         </div>
       </div>
     </>
  )
}
